/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const BlindSpotSensors = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 26" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M13.27 7.3l-1.14-1.14V4.61A4.1 4.1 0 0 0 8 .53H5.74a4.1 4.1 0 0 0-4.08 4.08V6.2h-.08L.44 7.39a.34.34 0 0 0 0 .48l.24.24a.33.33 0 0 0 .48 0l.5-.5v13.78a4.1 4.1 0 0 0 4.08 4.08H8a4.1 4.1 0 0 0 4.08-4.08V7.56l.46.46A.34.34 0 0 0 13 8l.24-.24a.33.33 0 0 0 .03-.46zM7 22.46c-1.92 0-3.4-2-3.4-2V18s1.33 2.5 3.45 2.5 3.33-2.5 3.33-2.5v2.49S8.92 22.46 7 22.46zM9.87 6.93A4.39 4.39 0 0 0 7.1 6.4c-1.003-.07-2 .2-2.83.77l-.86-1.86A4.52 4.52 0 0 1 7 3.78a4.48 4.48 0 0 1 3.65 1.36l-.78 1.79zM16.48 8.75a.5.5 0 0 0-.71 0 .5.5 0 0 0 0 .7 4.67 4.67 0 0 1 0 6.6.51.51 0 0 0 0 .71.51.51 0 0 0 .36.15.5.5 0 0 0 .35-.15 5.67 5.67 0 0 0 0-8.01z" /><path d="M19.31 6.92a.5.5 0 0 0-.71 0 .51.51 0 0 0 0 .71 7.25 7.25 0 0 1 0 10.25.51.51 0 0 0 0 .71c.2.187.51.187.71 0a8.27 8.27 0 0 0 0-11.67z" /><path d="M22.13 5.09a.5.5 0 0 0-.848.355.5.5 0 0 0 .148.355c3.828 3.847 3.828 10.063 0 13.91a.48.48 0 0 0 0 .7.48.48 0 0 0 .7 0 10.83 10.83 0 0 0 0-15.32z" /></g>
      </g>
    </svg>
  </span>
);

BlindSpotSensors.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

BlindSpotSensors.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default BlindSpotSensors;
